import { PortableText } from '@portabletext/react'

const RichText = ({ value, components }: { value: any, components: any }) => {
  return (
    <PortableText value={value} components={components} onMissingComponent={false} />
  )
}

export default RichText
